import { render, staticRenderFns } from "./KeywordCategoriesPopup.vue?vue&type=template&id=9a266400&scoped=true&lang=html"
import script from "./KeywordCategoriesPopup.vue?vue&type=script&lang=js"
export * from "./KeywordCategoriesPopup.vue?vue&type=script&lang=js"
import style0 from "./KeywordCategoriesPopup.vue?vue&type=style&index=0&id=9a266400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a266400",
  null
  
)

export default component.exports